import React, { useMemo } from 'react';
import HighlightedTTS from './HighlightedTTS';
import {
  highlightSanitizedRichContent,
  richContentPlainText,
  sanitizeRichContentWithMath
} from '../utils/richContent';

export default function SafeRichContent({ html = '', speechText = '', ttsEnabled = false, style = {}, className = '' }) {
  const safeHtml = useMemo(() => sanitizeRichContentWithMath(html), [html]);
  const readableText = useMemo(() => richContentPlainText(html), [html]);
  if (!ttsEnabled) {
    return <div className={className} style={style} dangerouslySetInnerHTML={{ __html: safeHtml }} />;
  }
  return (
    <div className={className} style={style}>
      <HighlightedTTS
        text={readableText}
        speechText={speechText}
        enabled
        size="small"
        highlightedStyle={{ backgroundColor: '#fef08a' }}
        renderContent={({ activeSpeechRange }) => (
          <div dangerouslySetInnerHTML={{
            __html: highlightSanitizedRichContent(safeHtml, readableText, activeSpeechRange)
          }} />
        )}
      />
    </div>
  );
}
